// @ts-strict-ignore
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ConnectionLevel } from './connection-level';
import { Connection } from '@3d-scene/model3d/connection';
import { NumberUtils } from '@shared/util/number-utils';
import { MathUtils } from '@3d-scene/common/util/math-utils';
import { MetaElementVO } from '@shared/vo/meta-element.vo';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';

export class ConnectionLevelUtils {
  public static createConnectionLevelsByProperties(articleContainer: ArticleContainer): ConnectionLevel[] {
    if (!articleContainer) {
      return [];
    }
    const connectionLevels: ConnectionLevel[] = [];
    const acceptingCubes: Connection[] = ConnectionInfoUtils.getAcceptingConnections([articleContainer]);
    for (const acceptingCube of acceptingCubes) {
      const levelNumber: number = this.getConnectionLevelByProperty(acceptingCube.metaElementVO);
      let connectionLevel: ConnectionLevel = this.getConnectionLevel(levelNumber, connectionLevels);
      if (!connectionLevel) {
        connectionLevel = new ConnectionLevel(levelNumber);
        connectionLevels.push(connectionLevel);
      }
      connectionLevel.addConnectionCube(acceptingCube);
    }
    this.sortConnectionlevels(connectionLevels);
    return connectionLevels;
  }

  private static sortConnectionlevels(connectionLevels: ConnectionLevel[]): void {
    if (!connectionLevels) {
      return;
    }
    connectionLevels.sort((a: ConnectionLevel, b: ConnectionLevel) => {
      if (NumberUtils.isNotNumber(a.levelNumber) && NumberUtils.isNotNumber(b.levelNumber)) {
        return 0;
      }
      if (NumberUtils.isNotNumber(a.levelNumber)) {
        return 1;
      }
      if (NumberUtils.isNotNumber(b.levelNumber)) {
        return -1;
      }
      return MathUtils.compare(a.levelNumber, b.levelNumber);
    });
  }

  public static getConnectionLevelByProperty(
    metaElement: MetaElementVO,
    considerAutogeneratedProperty: boolean = true
  ): number {
    let levelNumber: number = NaN;

    const manualLevelNumber: number = ConnectionInfoUtils.getLevelNumber(metaElement);
    if (NumberUtils.isNumber(manualLevelNumber)) {
      levelNumber = manualLevelNumber;
    } else if (considerAutogeneratedProperty) {
      levelNumber = ConnectionInfoUtils.getCalculatedLevelNumber(metaElement);
    }
    return levelNumber;
  }

  private static getConnectionLevel(levelNumber: number, sourceLevels: ConnectionLevel[]): ConnectionLevel {
    if (!sourceLevels) {
      return null;
    }
    for (const connectionLevel of sourceLevels) {
      if (
        (NumberUtils.isNotNumber(levelNumber) && NumberUtils.isNotNumber(connectionLevel.levelNumber)) ||
        levelNumber === connectionLevel.levelNumber
      ) {
        return connectionLevel;
      }
    }
    return null;
  }

  public static findConnectionLevel(levelNumber: number, connectionLevels: ConnectionLevel[]): ConnectionLevel {
    if (!connectionLevels) {
      return null;
    }
    for (const connectionLevel of connectionLevels) {
      if (connectionLevel.levelNumber === levelNumber || (NumberUtils.isNotNumber(connectionLevel.levelNumber) && levelNumber === 1)) {
        return connectionLevel;
      }
    }
    return null;
  }
}
